import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DownArrowIcon } from '../../assets/icons/down-arrow.svg';
import { ReactComponent as GlobeIcon } from '../../assets/icons/globe-icon.svg';
import { getCookie, setCookie } from '../../shared-functions/Cookies';
import MyButton from '../button/button';

const languages = [
  { code: 'en', lang: 'English' },
  { code: 'ar', lang: 'Arabic' },
  { code: 'fr', lang: 'French' },
  { code: 'sp', lang: 'Spanish'}
];

/**
 * Language Selector Component
 */
export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('en');

  // Load language from cookie or default to 'en'
  useEffect(() => {
    const savedLang = getCookie('i18next') || i18n.language || 'en';
    i18n.changeLanguage(savedLang);
    setCurrentLang(savedLang);
  }, [i18n]);

  /**
   * Change language and update cookie
   * @param lng - The target language code (e.g. 'en', 'ar').
   */
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setCookie('i18next', lng, null, null);
    setCurrentLang(lng);
    setOpen(false);
  };
 

  const currentLangFullName = languages.find((l) => l.code === currentLang)?.lang || 'English';

  useEffect(() => {
    const direction  = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.body.setAttribute('dir', direction );
  }, [i18n.language]);

  return (
    <div className="language-selector">
      <MyButton
        label={currentLangFullName}
        buttonType="outline"
        onClickFunc={() => setOpen(!open)}
        svgIcon={<GlobeIcon />}
        svgBackIcon={<DownArrowIcon />}
      />

      {open && (
        <div className="dropdown-menu">
          {languages.map((lng) => (
            <div
              key={lng.code}
              role="button"
              tabIndex={0}
              onClick={() => changeLanguage(lng.code)}
              onKeyDown={(even) => even.key === 'Enter' && changeLanguage(lng.code)}
              className={`menu-item ${lng.code === currentLang ? 'active' : ''}`}>
              {lng.lang}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
